(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace/create-game/assets/javascripts/create-game.js') >= 0) return;  svs.modules.push('/components/marketplace/create-game/assets/javascripts/create-game.js');

'use strict';

const _excluded = ["teamPathName"];
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
const _React = React,
  useEffect = _React.useEffect,
  useState = _React.useState;
const _ReactRedux = ReactRedux,
  useDispatch = _ReactRedux.useDispatch,
  useSelector = _ReactRedux.useSelector;
const _ReactRouterDOM = ReactRouterDOM,
  useHistory = _ReactRouterDOM.useHistory;
const DocumentTitle = svs.components.lbUtils.DocumentTitle;
const _svs$components$marke = svs.components.marketplace.createGame,
  CreateGameForm = _svs$components$marke.CreateGameForm,
  DrawSelection = _svs$components$marke.DrawSelection,
  ProductSelectionDropdown = _svs$components$marke.ProductSelectionDropdown;
const GroupHeader = svs.components.marketplace.groupHeader.GroupHeader;
const hooks = svs.components.marketplace.createGame.hooks;
const _svs$components$marke2 = svs.components.marketplaceData,
  selectors = _svs$components$marke2.selectors,
  games = _svs$components$marke2.games,
  createGame = _svs$components$marke2.createGame;
const selectTeam = svs.components.marketplaceData.selectors.teams.selectTeam;
const roles = svs.components.marketplaceData.auth.roles;
const getColor = svs.components.marketplace.colorHelper.getColor;
const loadFromLocalStorage = svs.components.marketplaceData.localStorage.actions.loadFromLocalStorage;
const CreateGame = () => {
  const dispatch = useDispatch();
  const _ReactRouterDOM$usePa = ReactRouterDOM.useParams(),
    teamPathName = _ReactRouterDOM$usePa.teamPathName,
    params = _objectWithoutProperties(_ReactRouterDOM$usePa, _excluded);
  const activatedDrawId = parseInt(params.activatedDrawId, 10);
  const containerId = parseInt(params.containerId, 10);
  const groupId = parseInt(params.groupId, 10);
  const history = useHistory();
  const _useState = useState(true),
    _useState2 = _slicedToArray(_useState, 2),
    isOpenProductSelector = _useState2[0],
    setIsOpenProductSelector = _useState2[1];
  const _useSelector = useSelector(state => state.CreateGame),
    errorMessage = _useSelector.errorMessage,
    selectedProductFromState = _useSelector.selectedProduct;
  const _hooks$useRedirectTo = hooks.useRedirectTo(),
    redirectToGame = _hooks$useRedirectTo.redirectToGame,
    redirectToTeam = _hooks$useRedirectTo.redirectToTeam;
  const game = useSelector(state => selectors.games.getGame(state, {
    activatedDrawId,
    groupId
  }));
  const me = useSelector(state => selectors.members.selectMe(state, {
    groupId
  }));
  const team = useSelector(state => selectTeam(state, {
    id: groupId
  }));
  const isEditable = Boolean(game) && games.helpers.canMemberEditGame(me, game);
  const title = isEditable ? 'Ändra spel' : 'Skapa ett nytt spel';
  const draws = useSelector(state => state.Draws.draws);
  useEffect(() => {
    if (Boolean(activatedDrawId) && errorMessage) {
      redirectToTeam({
        groupId,
        teamPathName,
        strategy: 'replace'
      });
    }
  }, [errorMessage, activatedDrawId, redirectToTeam, groupId, teamPathName]);
  useEffect(() => {
    if (!isEditable && activatedDrawId) {
      redirectToGame({
        activatedDrawId,
        containerId,
        groupId,
        strategy: 'push',
        teamPathName
      });
    }
  }, [activatedDrawId, containerId, groupId, isEditable, redirectToGame, teamPathName]);
  useEffect(() => {
    if (!activatedDrawId) {
      dispatch(createGame.actions.resetValues());
    }
  }, []);
  useEffect(() => {
    if (!activatedDrawId) {
      dispatch(loadFromLocalStorage());
    }
  }, []);
  useEffect(() => {
    const searchParams = new URLSearchParams(history.location.search);
    const preSelectedProduct = searchParams.get('productName') || selectedProductFromState;
    if (preSelectedProduct) {
      dispatch(createGame.actions.selectProduct(preSelectedProduct));
      setIsOpenProductSelector(false);
    }
    if (draws.loading === false) {
      const preSelectedDrawNumber = searchParams.get('drawNumber');
      if (preSelectedDrawNumber) {
        dispatch(createGame.actions.selectDraw(Number(preSelectedDrawNumber)));
      }
    }
  }, [dispatch, history.location.search, selectedProductFromState, draws.loading]);
  const goBack = () => {
    var _history$location;
    if ((_history$location = history.location) !== null && _history$location !== void 0 && (_history$location = _history$location.state) !== null && _history$location !== void 0 && _history$location.internalLink) {
      history.goBack();
    } else {
      redirectToTeam({
        strategy: 'replace',
        groupId,
        teamPathName
      });
    }
  };
  return React.createElement("div", {
    className: "create-game-holder"
  }, React.createElement(DocumentTitle, {
    title: activatedDrawId ? "Redigera spel - ".concat(team.name, " - Spela tillsammans | Svenska Spel") : "Skapa spel - ".concat(team.name, " - Spela tillsammans | Svenska Spel")
  }), React.createElement(GroupHeader, {
    className: "team-list-heading",
    color: getColor(team.id),
    groupId: team.id || team.groupId,
    isCaptain: team.role === roles.ROLES.CAPTAIN,
    isInverted: false,
    membersCount: team.membersCount,
    myRole: team.role,
    onGoBack: () => goBack(),
    teamName: team.name
  }), React.createElement("div", {
    className: "single-column-view create-game"
  }, React.createElement("div", {
    className: "create-game-container qa-active-form"
  }, React.createElement("div", {
    className: "margin-bottom-1 margin-md-top-3"
  }, React.createElement("div", {
    className: "create-game-container-product-info"
  }, React.createElement("h2", {
    className: "create-game-container-title f-medium f-700 margin-bottom-1"
  }, title), React.createElement(ProductSelectionDropdown, {
    hasOpenProductOnLoad: isOpenProductSelector
  }), React.createElement(DrawSelection, null)), errorMessage && React.createElement("p", {
    className: "margin-top-1"
  }, errorMessage), React.createElement(CreateGameForm, {
    isEditMode: Boolean(activatedDrawId)
  }), React.createElement("div", {
    className: "padding-xs-bottom padding-md-bottom-2"
  })))));
};
setGlobal('svs.components.marketplace.createGame.CreateGame', CreateGame);

 })(window);